import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  getUserRecordsCount,
  checkUserUsagePeriod,
  checkTeacherOrEditor,
} from "@/apis/naniexpert/services/member";
import type { CheckUserUsagePeriodRequest } from "@/types/apis/naniexpert";

export const USER_RECORDS_COUNT_QUERY_KEY = [
  "naniexpert",
  "userRecordsCount",
] as const;

type UseGetUserRecordsCountQueryOptions = {
  enabled?: boolean;
};

export const useGetUserRecordsCountQuery = (
  options: UseGetUserRecordsCountQueryOptions = {}
) => {
  const { enabled = true } = options;

  return useQuery({
    queryKey: USER_RECORDS_COUNT_QUERY_KEY,
    queryFn: getUserRecordsCount,
    enabled,
    refetchOnWindowFocus: true,
  });
};

export const useCheckTeacherOrEditorQuery = ({
  jwt,
  enabled = true,
}: {
  jwt: string;
  enabled?: boolean;
}) => {
  return useQuery({
    queryKey: ["naniexpert", "teacherOrEditorCheck", jwt],
    queryFn: checkTeacherOrEditor,
    enabled,
  });
};

export const useCheckUserUsagePeriodMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (body: CheckUserUsagePeriodRequest) =>
      checkUserUsagePeriod(body),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: USER_RECORDS_COUNT_QUERY_KEY });
    },
  });
};
